/** KPIs de operação do PDV (ticket 06-bloco-operacao-pdv) — separado do faturamento total da empresa. */
export class KpisOperacaoModel {
  faturado: number;
  cupons: number;
  ticketMedio: number;
  operadoresAtivos: number;
  caixasEmOperacao: number;
}

export function emptyKpisOperacao(): KpisOperacaoModel {
  return { faturado: 0, cupons: 0, ticketMedio: 0, operadoresAtivos: 0, caixasEmOperacao: 0 };
}
